<template>
  <v-container fluid>
    <v-expansion-panel class="mb-3" inset v-model="open">
      <v-expansion-panel-content class="CSP_BoarderStyle">
        <template v-slot:actions>
          <v-icon large color="primary">
            $vuetify.icons.expand
          </v-icon>
        </template>

        <template v-slot:header>
          <div>
            <v-icon color="primary">search</v-icon>
            <span class="pl-2 subheading">
              Custom Search Panel
            </span>
          </div>
        </template>

        <v-layout row wrap align-center>
          <v-flex class="mx-5">
            <v-layout class="mx-5" row wrap align-center>
              <v-text-field
                label="Registration Number"
                v-model="searchParam.reg_no"
                prepend-icon="edit"
              />
            </v-layout>
          </v-flex>

          <v-flex xs12 sm12 md12 class="mb-3">
            <v-layout justify-center row fill-height align-center>
              <v-btn outline round large @click="getTClistDetails">
                <v-icon left dark>search</v-icon>
                Search
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card color="white">
      <v-layout row>
        <v-card flat>
          <v-card-text class="title">
            College Transfer List
          </v-card-text>
        </v-card>

        <v-divider class="my-2" vertical />

        <v-spacer />
      </v-layout>
    </v-card>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="tcItems"
      class="elevation-1"
      :total-items="pagination.totalItems"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
    >
      <template v-slot:items="props">
        <td>{{ props.item.rn }}</td>

        <td class="text-xs">
          {{ props.item.reg_no }}
        </td>

        <td class="text-xs">
          {{ props.item.name }}
        </td>

        <td class="text-xs">
          {{ props.item.old_college_code }} -
          {{ props.item.old_college_name }}
        </td>

        <td class="text-xs">
          {{ props.item.new_college_code }} -
          {{ props.item.new_college_name }}
        </td>

        <td class="text-xs">
          {{ props.item.approved_date }}
        </td>

        <td class="justify-center text-xs-center">
          <v-item-group>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  small
                  color="primary"
                  v-on="on"
                  @click="editItem(props.item)"
                >
                  <v-icon class="mr-0" color="white">
                    info
                  </v-icon>
                </v-btn>
              </template>

              <span>Details</span>
            </v-tooltip>
          </v-item-group>
        </td>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      // Fix: v-model="open"
      open: 0,

      pagination: {
        page: 1,
        rowsPerPage: 10,
        rowsPerPageItems: [
          5,
          10,
          25,
          {
            text: "All",
            value: -1,
          },
        ],
        totalItems: 0,
        sortBy: "",
        descending: false,
      },

      totalDataItems: 0,

      loading: true,

      search: "",

      searchParam: {
        reg_no: "",
        page: 1,
        limit: 10,
        sort: "",
        search: "",
      },

      headers: [
        {
          text: "SL.",
          value: "rn",
          align: "left",
          sortable: false,
        },
        {
          text: "Registration Number",
          value: "reg_no",
          sortable: false,
        },
        {
          text: "Name",
          value: "name",
          sortable: false,
        },
        {
          text: "Old College Code & Name",
          value: "old_college_code",
          sortable: false,
        },
        {
          text: "New College Code & Name",
          value: "new_college_code",
          sortable: false,
        },
        {
          text: "Approved Date",
          value: "approved_date",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],

      degree: "",
    };
  },

  computed: {
    getTCList() {
      return (
        this.$store.getters.getTCData || {
          data: {
            data: [],
          },
          meta: {
            from: 0,
            total: 0,
          },
        }
      );
    },

    tcItems() {
      return this.getTCList.data && Array.isArray(this.getTCList.data.data)
        ? this.getTCList.data.data
        : [];
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getTClistDetails();
      },
      deep: true,
    },
  },

  created() {
    this.callPMSApi();
    this.searchParam.degree_code = this.degree;
  },

  methods: {
    setLimit() {
      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      this.searchParam.page = page;
      this.searchParam.limit = rowsPerPage;
      this.searchParam.sort = sortBy;
      this.searchParam.search = this.search;
    },

    callPMSApi() {
      const degree = JSON.parse(localStorage.getItem("loggedInExam"));
      this.degree = degree.degree_code;
    },

    getTClistDetails() {
      this.loading = true;

      this.setLimit();

      this.$store
        .dispatch("getTCListAdmin", this.searchParam)
        .then((data) => {
          this.loading = false;

          if (data && data.meta) {
            this.sl_count = data.meta.from;

            this.pagination.totalItems = data.meta.total || 0;
          }
        })
        .catch((error) => {
          this.loading = false;

          console.error("TC List API Error:", error);
        });
    },
  },
};
</script>

<style></style>
